export const USER_OPEN_LINK = 'user_open_link/'
export const USER_PUBLIC_INFO = `${USER_OPEN_LINK}info`
